export default __webpack_public_path__ + "static/winter45-51629b493ff40c87dcda1af22c4cab79.webp";